import React from 'react';

const SystemCheckbox = ({ 
  config, 
  componentShowingState, 
  isSystem, 
  handleIsSystemChange 
}) => {
  const STATE_EDIT = 'edit';

  const isMarkSystemEnabled = () => {
    return componentShowingState == STATE_EDIT && config.mark_system != undefined && config.mark_system.enabled && window.mark_system_enabled == 'true';
  };

  if (!isMarkSystemEnabled()) {
    return null;
  }

  return (
    <tr>
      <td colSpan="2">
        <div className="float-right">
          <input type="checkbox" className="pref" checked={isSystem} onChange={handleIsSystemChange} /> Kütüphaneye dahil
        </div>
      </td>
    </tr>
  );
};

export default SystemCheckbox;